module.exports = __webpack_public_path__ + "static/media/rightImg.699f30ce.svg";